import { useEffect, useRef, useState } from 'react';
import type { TarjetaAyuda } from '../marco/cabecera';
import { Icono } from './Icono';

/**
 * Botón «?» (componentes.md §3): botón de 44 redondo blanco con borde `--rv-rule` (abierto: negro) que despliega tarjetas
 * `--rv-paper` (radio 18, icono en baldosa blanca 32, título 14/700, texto 13) que caen escalonadas, colgadas bajo él.
 * Sin tarjetas, no hay «?». Esc o tocar fuera lo cierran.
 */
export function Ayuda({ tarjetas, alinear = 'derecha' }: { tarjetas: readonly TarjetaAyuda[]; alinear?: 'derecha' | 'izquierda' }) {
    const [abierta, setAbierta] = useState(false);
    const caja = useRef<HTMLDivElement>(null);
    useEffect(() => {
        if (!abierta) {
            return;
        }
        const fuera = (e: PointerEvent) => {
            if (caja.current !== null && !caja.current.contains(e.target as Node)) {
                setAbierta(false);
            }
        };
        const tecla = (e: KeyboardEvent) => {
            if (e.key === 'Escape') {
                setAbierta(false);
            }
        };
        document.addEventListener('pointerdown', fuera);
        document.addEventListener('keydown', tecla);
        return () => {
            document.removeEventListener('pointerdown', fuera);
            document.removeEventListener('keydown', tecla);
        };
    }, [abierta]);
    if (tarjetas.length === 0) {
        return null;
    }
    return (
        <div ref={caja} className="rv-ayuda">
            <button
                type="button"
                className="rv-bi rv-ayuda__b"
                aria-label="Cómo funciona"
                aria-expanded={abierta}
                onClick={() => {
                    setAbierta((a) => !a);
                }}
            >
                <Icono nombre="circle-help" />
            </button>
            <div role="dialog" aria-label="Cómo funciona" aria-hidden={!abierta} className={`rv-ayuda__lista rv-ayuda__lista--${alinear}`} style={{ visibility: abierta ? 'visible' : 'hidden' }}>
                {tarjetas.map((t, i) => (
                    <div key={t.titulo} className="rv-ayuda__tarjeta" style={{ transform: abierta ? 'none' : 'translateY(-16px)', opacity: abierta ? 1 : 0, transitionDelay: `${String(abierta ? i * 60 : 0)}ms` }}>
                        <span className="rv-ayuda__baldosa">
                            <Icono nombre={t.icono} />
                        </span>
                        <span>
                            <strong>{t.titulo}</strong>
                            <span>{t.texto}</span>
                        </span>
                    </div>
                ))}
            </div>
        </div>
    );
}
